/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Inspector_WeightInputs */

const en_image_inspector_weight = /** @type {(inputs: Image_Inspector_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weight`)
};

const ar_image_inspector_weight = /** @type {(inputs: Image_Inspector_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الحجم`)
};

const bn_image_inspector_weight = /** @type {(inputs: Image_Inspector_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সাইজ`)
};

const de_image_inspector_weight = /** @type {(inputs: Image_Inspector_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dateigröße`)
};

const es_image_inspector_weight = /** @type {(inputs: Image_Inspector_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso`)
};

const fr_image_inspector_weight = /** @type {(inputs: Image_Inspector_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poids`)
};

const pt_image_inspector_weight = /** @type {(inputs: Image_Inspector_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamanho`)
};

const zh_image_inspector_weight = /** @type {(inputs: Image_Inspector_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大小`)
};

const tr_image_inspector_weight = /** @type {(inputs: Image_Inspector_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dosya boyutu`)
};

const ru_image_inspector_weight = /** @type {(inputs: Image_Inspector_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вес`)
};

const pl_image_inspector_weight = /** @type {(inputs: Image_Inspector_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozmiar`)
};

/**
* | output |
* | --- |
* | "Weight" |
*
* @param {Image_Inspector_WeightInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_weight = /** @type {((inputs?: Image_Inspector_WeightInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_WeightInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_weight(inputs)
	if (locale === "bn") return bn_image_inspector_weight(inputs)
	if (locale === "de") return de_image_inspector_weight(inputs)
	if (locale === "es") return es_image_inspector_weight(inputs)
	if (locale === "fr") return fr_image_inspector_weight(inputs)
	if (locale === "pt") return pt_image_inspector_weight(inputs)
	if (locale === "zh") return zh_image_inspector_weight(inputs)
	if (locale === "tr") return tr_image_inspector_weight(inputs)
	if (locale === "ru") return ru_image_inspector_weight(inputs)
	if (locale === "pl") return pl_image_inspector_weight(inputs)
	return en_image_inspector_weight(inputs)
});